import React from 'react';
import {
    Drawer,
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Collapse,
} from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import PriceChangeRoundedIcon from '@mui/icons-material/PriceChangeRounded';
import LocalMallRoundedIcon from '@mui/icons-material/LocalMallRounded';
import InventoryIcon from '@mui/icons-material/Inventory';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const LeftSidebar = ({ open, onClose }) => {
    const [financeOpen, setFinanceOpen] = React.useState(false);

    const handleFinanceClick = () => {
        setFinanceOpen(!financeOpen);
    };

    const handleLinkClick = () => {
        onClose();
    };

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 280,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box sx={{ width: 280 }} role="presentation">
                {/* Header with close button */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2,
                        borderBottom: '1px solid #e0e0e0',
                    }}
                >
                    <a
                        href={`https://${process.env.REACT_APP_DOMAIN}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#1976d2',
                            textDecoration: 'none'
                        }}
                    >
                        {process.env.REACT_APP_NAME}.com
                    </a>
                    <IconButton onClick={onClose} size="small" sx={{ color: '#1976d2' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Menu items */}
                <List>
                    {/* Bảng giá và Gia hạn */}
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/dashboard/price" onClick={handleLinkClick}>
                            <ListItemIcon>
                                <PriceChangeRoundedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Bảng giá và Gia hạn" />
                        </ListItemButton>
                    </ListItem>

                    <Divider />

                    {/* Quản lý đơn hàng */}
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/dashboard/order" onClick={handleLinkClick}>
                            <ListItemIcon>
                                <LocalMallRoundedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Quản lý đơn hàng" />
                        </ListItemButton>
                    </ListItem>

                    <Divider />

                    {/* Quản lý hàng hóa */}
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/dashboard/product" onClick={handleLinkClick}>
                            <ListItemIcon>
                                <InventoryIcon />
                            </ListItemIcon>
                            <ListItemText primary="Quản lý hàng hóa" />
                        </ListItemButton>
                    </ListItem>

                    <Divider />

                    {/* Thu chi (with submenu) */}
                    <ListItem disablePadding>
                        <ListItemButton onClick={handleFinanceClick}>
                            <ListItemIcon>
                                <BarChartRoundedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Thu chi" />
                            {financeOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={financeOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/dashboard/revenue"
                                onClick={handleLinkClick}
                            >
                                <ListItemIcon>
                                    <TrendingUpIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Thu" />
                            </ListItemButton>
                            <ListItemButton
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/dashboard/expense"
                                onClick={handleLinkClick}
                            >
                                <ListItemIcon>
                                    <TrendingDownIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Chi" />
                            </ListItemButton>
                        </List>
                    </Collapse>

                    <Divider />

                    {/* Tính cước */}
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/dashboard/fee" onClick={handleLinkClick}>
                            <ListItemIcon>
                                <LocalShippingRoundedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Tính cước" />
                        </ListItemButton>
                    </ListItem>

                    <Divider />

                    {/* Check bom hàng */}
                    <ListItem disablePadding>
                        <ListItemButton component={Link} to="/dashboard/check-phone-number" onClick={handleLinkClick}>
                            <ListItemIcon>
                                <ReportProblemRoundedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Check bom hàng" />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </Drawer>
    );
};

export default LeftSidebar;
